import { get } from "lodash";
import { CLIENT_CERTIFICATE_ERROR, CLIENT_CERTIFICATE_REQUEST, CLIENT_CERTIFICATE_SUCCESS, CREATE_CSR_CERTIFICATE_ERROR, CREATE_CSR_CERTIFICATE_REQUEST, CREATE_CSR_CERTIFICATE_SUCCESS, EMAIL_SETTINGS_CREATE_ERROR, EMAIL_SETTINGS_CREATE_REQUEST, EMAIL_SETTINGS_CREATE_SUCCESS, FETCH_EMAIL_SETTINGS_CERTIFICATE_ERROR, FETCH_EMAIL_SETTINGS_CERTIFICATE_SUCCESS, FETCH_EMAIL_SETTINGS_ERROR, FETCH_EMAIL_SETTINGS_REQUEST, FETCH_EMAIL_SETTINGS_SUCCESS } from "../../constants";


const initialState = {
  isLoading: false,
  emailSettingsData: {
    error: null,
    data: null,
  },
  initialData: {
    error: null,
    data: null,
  },
  certificatesData: {
    data: null,
    error: null,
  },
  createCertificate: {
    data: null,
    error: null,
  },
  clientCertificate: {
    data: null,
    error: null,
  },
}

export default function (state = initialState, action) {
  switch (action.type) {
    case EMAIL_SETTINGS_CREATE_REQUEST:
      return {
        ...state,
        isLoading: action.loading,
        emailSettingsData: {
          data: null,
          error: null,
        },
        clientCertificate: {
          error: null,
        },
      }
    case EMAIL_SETTINGS_CREATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        emailSettingsData: {
          data: action.payload,
          error: null,
        },
        clientCertificate: {
          error: null,
        },
      }
    case EMAIL_SETTINGS_CREATE_ERROR:
      return {
        ...state,
        isLoading: false,
        emailSettingsData: {
          data: null,
          error: action.payload,
        },
        clientCertificate: {
          error: null,
        },
      }
      case FETCH_EMAIL_SETTINGS_REQUEST:
        return {
          ...state,
          isLoading: action.loading,
          initialData: {
            data: null,
            error: null,
          },
        }
    case FETCH_EMAIL_SETTINGS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        initialData: {
          data: action.payload,
          error: null,
        },
      }
    case FETCH_EMAIL_SETTINGS_ERROR:
      return {
        ...state,
        isLoading: false,
        initialData: {
          data: null,
          error: action.payload,
        },
      }
    case FETCH_EMAIL_SETTINGS_CERTIFICATE_SUCCESS:
      return {
        ...state,
        certificatesData: {
          data: action.payload,
          error: null,
        },
      }
    case FETCH_EMAIL_SETTINGS_CERTIFICATE_ERROR:
      return {
        ...state,
        certificatesData: {
          data: null,
          error: action.payload,
        },
      }
    case CREATE_CSR_CERTIFICATE_REQUEST:
      return {
        ...state,
        isLoading: action.loading,
        createCertificate: {
          data: null,
          error: null,
        },
      }
    case CREATE_CSR_CERTIFICATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        createCertificate: {
          data: action.payload,
          error: null,
        },
      }
    case CREATE_CSR_CERTIFICATE_ERROR:
      return {
        ...state,
        isLoading: false,
        createCertificate: {
          data: null,
          error: action.payload,
        },
      }
      case CLIENT_CERTIFICATE_REQUEST:
      return {
        ...state,
        isLoading: action.loading,
        clientCertificate: {
          data: null,
          error: null,
        },
        emailSettingsData: {
          error: null,
        },
      }
    case CLIENT_CERTIFICATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        clientCertificate: {
          data: action.payload,
          error: null,
        },
        emailSettingsData: {
          error: null,
        },
      }
    case CLIENT_CERTIFICATE_ERROR:
      return {
        ...state,
        isLoading: false,
        clientCertificate: {
          data: null,
          error: action.payload,
        },
        emailSettingsData: {
          error: null,
        },
      }
    default:
      return state;
  }
}

export const getEmailSettingsDetails = ((state) => get(state, 'emailSettings.initialData.data.notificationConfig'))
export const getEmailSettingsCreateError = ((state) => get(state, 'emailSettings.emailSettingsData.error[0].response.data.error.message.value'))
export const getEmailSettingsCreateValidationError = ((state) => get(state, 'emailSettings.emailSettingsData.error[0].error'))
export const getIsLoading = ((state) => get(state, 'emailSettings.isLoading'))
export const getCertificatesData = ((state) => get(state, 'emailSettings.certificatesData.data'))
export const getCreatedCsrCertificate = ((state) => get(state, 'emailSettings.createCertificate.data'))
export const getCreatedCsrCertificateError = ((state) => get(state, 'emailSettings.createCertificate.error[0].response.data.error.message.value'))
export const getInvalidClientCertificateError = ((state) => get(state, 'emailSettings.clientCertificate.error[0].error'))
export const getClientCertificateError = ((state) => get(state, 'emailSettings.clientCertificate.error[0].response.data.error'))
export const getClientCertificateSuccess = ((state) => get(state, 'emailSettings.clientCertificate.data'))